module.exports = "<div class=\"panel panel-default m-b-10\">\r\n  <div class=\"panel-heading p-t-b-3 f-s-16 bg-white\">{{currentLanguageSet?.rating}}</div>\r\n  <div class=\"panel-body\">{{currentLanguageSet?.panelContent}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/rating/rating.component.html
// module id = ../../../../../src/app/rating/rating.component.html
// module chunks = 0